import { useVisualComponentsContext } from '../../contexts/visualComponents';
import { useQueryHistoryStateContext, useQueryStateContext } from '../../contexts';
import { useAddCondition } from '../../hooks/condition';

export const AddButton = () => {
  const { AddConditionButton } = useVisualComponentsContext();
  const { isReadOnly = false } = useQueryStateContext();
  const addCondition = useAddCondition();
  const { resetRedoStack } = useQueryHistoryStateContext();

  if (isReadOnly) return null;

  return (
    <AddConditionButton
      isDisabled={isReadOnly}
      onClick={() => {
        addCondition();
        resetRedoStack();
      }}
    />
  );
};
